/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface ObstacleType {
}

export enum ObstacleType_Enum {
  UNKNOWN = 0,
  SPHERE = 1,
  DOORWAY = 2,
  CEILING_FLOOR = 3,
  WALL = 4,
  BOX = 5,
  UNRECOGNIZED = -1,
}

export function obstacleType_EnumFromJSON(object: any): ObstacleType_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return ObstacleType_Enum.UNKNOWN;
    case 1:
    case "SPHERE":
      return ObstacleType_Enum.SPHERE;
    case 2:
    case "DOORWAY":
      return ObstacleType_Enum.DOORWAY;
    case 3:
    case "CEILING_FLOOR":
      return ObstacleType_Enum.CEILING_FLOOR;
    case 4:
    case "WALL":
      return ObstacleType_Enum.WALL;
    case 5:
    case "BOX":
      return ObstacleType_Enum.BOX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ObstacleType_Enum.UNRECOGNIZED;
  }
}

export function obstacleType_EnumToJSON(object: ObstacleType_Enum): string {
  switch (object) {
    case ObstacleType_Enum.UNKNOWN:
      return "UNKNOWN";
    case ObstacleType_Enum.SPHERE:
      return "SPHERE";
    case ObstacleType_Enum.DOORWAY:
      return "DOORWAY";
    case ObstacleType_Enum.CEILING_FLOOR:
      return "CEILING_FLOOR";
    case ObstacleType_Enum.WALL:
      return "WALL";
    case ObstacleType_Enum.BOX:
      return "BOX";
    case ObstacleType_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseObstacleType(): ObstacleType {
  return {};
}

export const ObstacleType = {
  encode(_: ObstacleType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ObstacleType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObstacleType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ObstacleType {
    return {};
  },

  toJSON(_: ObstacleType): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ObstacleType>, I>>(base?: I): ObstacleType {
    return ObstacleType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObstacleType>, I>>(_: I): ObstacleType {
    const message = createBaseObstacleType();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
